import axios from "axios";
import fetchToken from './tokenAuth';
import GetUserData from "../utilities/getUserDetails";
import { stringifyReactNode } from "rsuite/esm/internals/utils";

//author-saksham
//function-to call api through out the application

const ApiRequest = async ({ apiLink, method, data, getToken }) => {
  try {
    let token = null;
    // let token = localStorage.getItem('authToken');
    if ((!token || token === "undefined" || token === '[object Object]') && getToken != 'No') {
      token = await fetchToken();
      if (!token) {
        throw new Error("No token available");
      }
    }

    const options = {
      method: method,
      url: apiLink,
      // origin: 'https://staging2.lalpathlabs.com',
      origin: 'https://webapi.lalpathlabs.com',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: new URLSearchParams(data),
    };
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error("Error making API request:", error);
    return null;
  }
};

export default ApiRequest;
//end